import { useMutation } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";
import { useReporting } from "render/hooks/useReporting";

export type BarcodeAssignmentMode = "assign" | "reassign";

type Variables = {
  patientId: string;
  visitId: string;
  barcodeId: string;
  mode: BarcodeAssignmentMode;
};

export function useBarcodeAssignmentMutation() {
  const api = useAPIClient();
  const { handleError } = useReporting();

  return useMutation({
    mutationFn({ patientId, visitId, barcodeId, mode }: Variables) {
      switch (mode) {
        case "assign":
          return api.bloodSample.assignBarcode(
            { patientId },
            { visitId, barcodeId }
          ).result;
        case "reassign":
          return api.bloodSample.reassignBarcode(
            { patientId },
            { visitId, newBarcodeId: barcodeId }
          ).result;
      }
    },
    onError: (error) => handleError(error),
  });
}
